import { RouteObject } from "react-router-dom";

const croatianOlympicCommitteeRoutes: RouteObject[] = [
	{
		path: "kategorizacija",
		lazy: () => import("@/pages/Page"),
		children: [
			{ path: "registri", lazy: () => import("@/pages/CroatianOlympicCommittee/CroatianOlympicCommitteeCodebooks") },
			{
				path: "organizacije",
				lazy: () => import("@/pages/CroatianOlympicCommittee/Organizations/CroatianOlympicCommitteeOrganizations")
			},
			{
				path: "organizacije/:organizationId",
				lazy: () => import("@/pages/CroatianOlympicCommittee/Organizations/OrganizationDetailsPage")
			},
			{ path: "sportasi", lazy: () => import("@/pages/CroatianOlympicCommittee/Athletes/AthletesPage") },
			{ path: "sportasi/:athleteId", lazy: () => import("@/pages/CroatianOlympicCommittee/Athletes/AthleteDetailsPage") },
			{ path: "kategorije", lazy: () => import("@/pages/CroatianOlympicCommittee/Categories/CategoriesPage") },
			{ path: "kategorije/:categoryId", lazy: () => import("@/pages/CroatianOlympicCommittee/Categories/CategoryDetailsPage") },
			{ path: "zahtjevi", lazy: () => import("@/pages/CroatianOlympicCommittee/CategoryRequests/CategoryRequestsPage") },
			{
				path: "zahtjevi/:categoryRequestId",
				lazy: () => import("@/pages/CroatianOlympicCommittee/CategoryRequests/CategoryRequestDetailsPage")
			},

			{
				path: "obrasci",
				lazy: () => import("@/pages/Page"),
				children: [
					{
						path: "kategorizacija-sportasa",
						children: [
							{ path: "", lazy: () => import("@/pages/CroatianOlympicCommittee/CategoryRequestForms/CategoryRequestNewFormPage") },
							{
								path: ":categoryRequestFormId",
								lazy: () => import("@/pages/CroatianOlympicCommittee/CategoryRequestForms/CategoryRequestFormDetailsPage")
							}
						]
					},
					{
						path: "promjena-kluba",
						children: [
							{ path: "", lazy: () => import("@/pages/CroatianOlympicCommittee/CategoryRequestForms/CategoryRequestOrganizationChangeFormPage") },
							{
								path: ":categoryRequestFormId",
								lazy: () => import("@/pages/CroatianOlympicCommittee/CategoryRequestForms/CategoryRequestFormDetailsPage")
							}
						]
					},
					{
						path: "produljenje",
						children: [
							{ path: "", lazy: () => import("@/pages/CroatianOlympicCommittee/CategoryRequestForms/CategoryRequestExtensionFormPage") },
							{
								path: ":categoryRequestFormId",
								lazy: () => import("@/pages/CroatianOlympicCommittee/CategoryRequestForms/CategoryRequestFormDetailsPage")
							}
						]
					},
					{
						path: "svi",
						children: [
							{ path: "", lazy: () => import("@/pages/CroatianOlympicCommittee/CategoryRequestForms/CategoryRequestFormAllPage") },
							{
								path: ":categoryRequestFormId",
								lazy: () => import("@/pages/CroatianOlympicCommittee/CategoryRequestForms/CategoryRequestFormDetailsPage")
							}
						]
					},
					{
						path: ":categoryRequestFormId",
						lazy: () => import("@/pages/CroatianOlympicCommittee/CategoryRequestForms/CategoryRequestFormDetailsPage")
					}
				]
			}
		]
	},
];

export default croatianOlympicCommitteeRoutes;